export const getters = {
  selectedAddEditDetails: ({ selectedDataSetDetails }) => {
    let dataset = selectedDataSetDetails ? selectedDataSetDetails : {};
    const resetValues = {
      AutoUpload: !!dataset.AutoUpload,
      AutoImportV3: !!dataset.AutoImportV3,
      AppendDataV3: !!dataset.AppendDataV3,
      FileStorageType: dataset.FileStorageType ? dataset.FileStorageType : 'SFTP_Virtual_Machine'
    };
    return { ...dataset, ...resetValues };
  },
  list: (state) => state.dataset,
  sftpDatasetList: (state) => state.dataset.filter((d) => d.FileStorageType.toLowerCase() !== 'blob'),
  sftpV3DatasetList: (state, getters) => getters.sftpDatasetList.filter((d) => d.AzureFunctionEnable),
  sftpV2DatasetList: (state, getters) => getters.sftpDatasetList.filter((d) => !d.AzureFunctionEnable),
  blobV3DatasetList: (state) =>
    state.dataset.filter((d) => d.FileStorageType.toLowerCase() === 'blob' && d.AzureFunctionEnable),
  blobV2DatasetList: (state) =>
    state.dataset.filter((d) => d.FileStorageType.toLowerCase() === 'blob' && !d.AzureFunctionEnable)
};
